import { render, staticRenderFns } from "./CharacterNameValue.vue?vue&type=template&id=32d2fc8e&lang=pug&"
import script from "./CharacterNameValue.vue?vue&type=script&lang=js&"
export * from "./CharacterNameValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterNameValue.vue"
export default component.exports